import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import arr from 'dojo/_base/array';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './LocationPreview.html?raw';
import query from 'dojo/query';
// NOTE (JS2TS): original define() also listed dojo deps never referenced in code and not used via
// data-dojo-type (connect, Color, keys, dijit registry) — dead, dropped.

const domConstruct: any = domConstructTyped;

class LocationPreview extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    images: any = [];
    entity: any = null;
    _slideIndex = 1;
    slideShowEnabled = false;

    _setEntityAttr(value: any): void {
        this.entity = value;
    }
    _getEntityAttr(): any {
        return this.entity;
    }

    _setHeadlineAttr(value: any): void {
        domAttr.set(this.headline, "innerHTML", value);
    }
    _getHeadlineAttr(): any {
        return domAttr.get(this.headline, "innerHTML");
    }

    _setSubtextAttr(value: any): void {
        domAttr.set(this.subtext, "innerHTML", value);
    }
    _getSubtextAttr(): any {
        return domAttr.get(this.subtext, "innerHTML");
    }

    addNode(node: any, target: any, pos: any): void {
        // targets = "topRightContainer", "headline", "subtext", "contentLeftContainer", "img1Container", "img2Container", "img3Container", "img4Container"
        // pos =  "before", "after", "replace", "only", "first", or "last"
        domConstruct.place(node, this[target], pos);
    }

    addImage(urlThumbnail: any, urlFullsize: any, title: any): void {

        // img für 2 Spalten 2 Zeilen Darstellung
        var img = domConstruct.create("img", {
            src: urlThumbnail,
            onerror: "this.style = 'display:none;'",
            style: {
                cursor: "pointer",
                width: "100%",
                height: "200px",
                objectFit: "cover"
            },
            className: "w3-hover-shadow",
        });

        // img für nav-leiste in slideshow
        var slideNavImg = lang.clone(img);
        domClass.add(slideNavImg, "w3-opacity");
        domClass.add(slideNavImg, "w3-hover-opacity-off");
        domClass.add(slideNavImg, "slideNavImg");
        domAttr.set(slideNavImg, "alt", title);

        // img für slideshow
        var slideImg = domConstruct.create("img", {
            src: urlFullsize,
            style: {
                maxWidth: "600px",
                height: "500px",
                objectFit: "cover",
                cursor: "pointer",
                display: "none"
            },
            className: "slideImg w3-hover-shadow",
        });

        // registry merkt sich alles
        //
        var imgRegistryEntry = {
            url: urlFullsize,
            urlThumb: urlThumbnail,
            title: title,
            imgNode: img,
            slideImgNode: slideImg,
            slideNavImgNode: slideNavImg
        };
        this.images.push(imgRegistryEntry);

        on(img, "click", lang.hitch(this, "_onClick_Img", imgRegistryEntry));
        on(slideNavImg, "click", lang.hitch(this, "_onClick_NavImg", imgRegistryEntry));



        // anzeige der bilder

        // 2 Spalten 2 Zeilen Darstellung
        var targetContainerName = "img" + this.images.length + "Container";
        domConstruct.place(img, this[targetContainerName]);

        // slideshow img
        domConstruct.place(slideImg, this.imgSlidesContainer);

        // slideshow nav img
        var targetContainerName = "SlideImg" + this.images.length + "Container";
        domConstruct.place(slideNavImg, this[targetContainerName]);

    }

    _onClick_Img(imgEntry: any): void {
        if (this.slideShowEnabled) {
            this.showSlideshow(imgEntry);
        }
    }

    _onClick_NavImg(imgEntry: any): void {
        this.showSlideshow(imgEntry);
    }

    _onClick_CloseSlideShow(): void {
        this.closeSlideshow();
    }

    _onClick_SlideShow_Prev(): void {
        this.slideShowActivateImage(this._slideIndex += -1);
    }

    _onClick_SlideShow_Next(): void {
        this.slideShowActivateImage(this._slideIndex += 1);
    }

    showSlideshow(imgEntry: any): void {

        domAttr.set(this.slideShowCaption, "innerHTML", this.get("headline"));
        domStyle.set(this.modalSlideshow, "display", "block");
        this.slideShowActivateImage(this._slideIndex = (arr.indexOf(this.images, imgEntry) + 1));
    }
    closeSlideshow(): void {
        domStyle.set(this.modalSlideshow, "display", "none");
    }

    slideShowActivateImage(n: any): void {
        var i;

        var x: any = query(".slideImg", this.modalSlideshow);
        var dots: any = query(".slideNavImg", this.modalSlideshow);

        var captionText = this.get("headline");
        if (n > x.length) { this._slideIndex = 1 }
        if (n < 1) { this._slideIndex = x.length }
        for (i = 0; i < x.length; i++) {
            x[i].style.display = "none";
        }
        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" w3-opacity-off", "");
        }
        x[this._slideIndex - 1].style.display = "block";
        dots[this._slideIndex - 1].className += " w3-opacity-off";
    }

    clearImages(): void {
        this.images = [];

        if (this.img1Container.childNodes.length > 0)
            domConstruct.empty(this.img1Container);

        if (this.img2Container.childNodes.length > 0)
            domConstruct.empty(this.img2Container);

        if (this.img3Container.childNodes.length > 0)
            domConstruct.empty(this.img3Container);

        if (this.img4Container.childNodes.length > 0)
            domConstruct.empty(this.img4Container);

        domConstruct.empty(this.imgSlidesContainer);

        domConstruct.empty(this.SlideImg1Container);
        domConstruct.empty(this.SlideImg2Container);
        domConstruct.empty(this.SlideImg3Container);
        domConstruct.empty(this.SlideImg4Container);
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        this.images = [];
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);

    }
}
LocationPreview.prototype.declaredClass = 'more.Legacy.Zal.LocationPreview';

export default mdsWidget(LocationPreview);
